import Marquee from "react-fast-marquee";
import {
  SiGithub,
  SiLinear,
  SiJira,
  SiHubspot,
  SiGooglecalendar,
  SiGmail,
  SiNotion,
  SiGitlab,
} from "react-icons/si";
import { Slack, Cloud } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const CONNECTORS = [
  { name: "GitHub", Icon: SiGithub, tier: "Launch" },
  { name: "Linear", Icon: SiLinear, tier: "Launch" },
  { name: "Jira", Icon: SiJira, tier: "Launch" },
  { name: "HubSpot", Icon: SiHubspot, tier: "Launch" },
  { name: "Google Calendar", Icon: SiGooglecalendar, tier: "Launch" },
  { name: "Gmail", Icon: SiGmail, tier: "Launch" },
  { name: "Slack", Icon: Slack, tier: "Launch" },
  { name: "Salesforce", Icon: Cloud, tier: "Fast follow" },
  { name: "Notion", Icon: SiNotion, tier: "Fast follow" },
  { name: "GitLab", Icon: SiGitlab, tier: "Fast follow" },
];

export const Integrations = () => (
  <section id="integrations" data-testid="integrations-section" className="bg-white">
    <div className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-36">
      <SectionLabel index="06" title="Connects where work happens" />
      <Reveal className="mt-10">
        <h2 className="max-w-4xl text-[28px] font-bold leading-tight tracking-tight md:text-[40px]">
          Reads the systems where work actually happens.{" "}
          <span className="text-black/40">Never asks for a status update.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-6 max-w-2xl">
        <p className="text-base leading-relaxed text-black/70 md:text-lg">
          OAuth, incremental sync, webhook-driven. Two connectors are enough to produce real value —
          and Qwiri only ever inherits the access you already hold. It never grants more.
        </p>
      </Reveal>
    </div>

    <div className="border-y-2 border-black">
      <Marquee speed={24} gradient={false} pauseOnHover>
        {CONNECTORS.map(({ name, Icon, tier }) => (
          <div
            key={name}
            data-testid={`connector-${name.toLowerCase().replace(/\s/g, "-")}`}
            className="group mx-3 my-8 flex w-56 flex-col gap-4 border-2 border-black bg-white p-6 transition-colors duration-150 hover:bg-black hover:text-white"
          >
            <Icon size={30} />
            <div>
              <div className="text-base font-bold tracking-tight">{name}</div>
              <div className="mt-1 text-[10px] font-bold uppercase tracking-[0.2em] text-black/45 group-hover:text-white/60">
                {tier}
              </div>
            </div>
          </div>
        ))}
      </Marquee>
    </div>

    <div className="mx-auto max-w-[1440px] px-5 pt-10 md:px-10">
      <Reveal>
        <p className="text-[11px] font-bold uppercase tracking-[0.25em] text-black/50 md:text-[13px]" data-testid="integrations-note">
          Personal scope stays personal — projected facts, never artifacts
        </p>
      </Reveal>
    </div>
  </section>
);
